/**
 * Calculate sellable quantity based on the oos threshold
 */
export const calculateSellableQty = (
  erpQty: string,
  productThreshold: string,
  storeThreshold?: string,
  useStoreThreshold: boolean = false,
): string => {
  const erpQuantity = Number(erpQty)

  const oosThreshold = useStoreThreshold
    ? Number(storeThreshold) || 0
    : Number(productThreshold) || 0

  if (erpQuantity === 0) return '0'

  return Math.max(0, erpQuantity - oosThreshold).toString()
}
